var map = {
	"./api.js": "P9l9",
	"./index.js": "gyMJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cmqu";


//////////////////
// WEBPACK FOOTER
// ./src/api \.js$
// module id = cmqu
// module chunks = 7